import { Tabs, Tab, Breadcrumbs } from '../../../../../components';
import CallsTasksList from './CallsTasksList';

type TabsEnum = 'analytics' | 'callsManagement';

const CallsManagementPage = () => {
  return (
    <>
      <div className="flex flex-col mb-lg">
        <Breadcrumbs
          className="mb-xs text-small"
          items={[
            { label: 'Mass Outreach', url: '/batch_calls' },
            { label: 'Task Name', url: '' },
          ]}
        />
        <h1 className="text-section font-semibold">Task Name</h1>
      </div>
      <Tabs<TabsEnum>
        tabs={[
          { name: 'analytics', label: 'Analytics' },
          { name: 'callsManagement', label: 'Calls Management' },
        ]}
        contentClassName="mt-md"
      >
        <Tab name="analytics"></Tab>
        <Tab name="callsManagement">
          <CallsTasksList />
        </Tab>
      </Tabs>
    </>
  );
};

export default CallsManagementPage;
